import { urlEncode } from '@services/Url';

const serializeFormData = data => ({
  contentGuidString: data.contentGuidString,
  title: data.title,
  company: data.company,
  location: data.location,
  ctaLabel: data.ctaLabel,
  ctaUrl: data.ctaUrl,
  activeDate: data.activeDate,
  createdDate: data.createdDate,
  createdBy: data.createdBy,
});

const eBarJobsCreate = async (data) => {
  const eBarCreate = await fetch('/EBarJobsCallToActionBlock/CreateEpiJobs', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    body: urlEncode({
      input: JSON.stringify(serializeFormData(data)),
    }),
  });
  const eBarCreateJson = eBarCreate.json();

  return eBarCreateJson;
};

const eBarJobsUpdate = async (data) => {
  const eBarUpdate = await fetch('/EBarJobsCallToActionBlock/UpdateEpiJobs', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    body: urlEncode({
      input: JSON.stringify(serializeFormData(data)),
    }),
  });
  const eBarUpdateJson = eBarUpdate.json();

  return eBarUpdateJson;
};

const eBarJobsDelete = async (data) => {
  const eBarDelete = await fetch('/EBarJobsCallToActionBlock/DeleteEpiJobs', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    body: urlEncode({
      stringToDelete: data,
    }),
  });
  const eBarDeleteJson = eBarDelete.json();

  return eBarDeleteJson;
};


export {
  eBarJobsCreate,
  eBarJobsUpdate,
  eBarJobsDelete,
};
